import React from 'react';
import { Mail } from 'lucide-react';

const Section = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="text-xl md:text-2xl font-bold text-[#1e1b4b] uppercase tracking-tight">{title}</h2>
    <div className="w-16 h-0.5 bg-[#f26b1f] mt-2 mb-4" />
    <div className="space-y-3">{children}</div>
  </div>
);

const Privacybeleid = () => (
  <div>
    <section className="hero-gradient text-white py-14">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h1 className="text-4xl md:text-5xl font-bold uppercase">Privacybeleid</h1>
        <p className="text-slate-200 mt-2">Laatst bijgewerkt: 2026 - AVG-conform</p>
      </div>
    </section>
    <article className="max-w-4xl mx-auto px-4 md:px-6 py-10 prose-content">
      <Section title="1. Definities en Toepasselijkheid">
        <p><strong>1.1</strong> Onder “Bezwaarmeesters.nl” wordt verstaan: de onderneming Bezwaarmeesters.nl, gevestigd in Nederland en ingeschreven bij de Kamer van Koophandel.</p>
        <p><strong>1.2</strong> Onder “cliënt” wordt verstaan: de natuurlijke of rechtspersoon die een overeenkomst aangaat met Bezwaarmeesters.nl en diens persoonsgegevens verstrekt.</p>
        <p><strong>1.3</strong> Dit privacybeleid is van toepassing op alle verwerkingen van persoonsgegevens door Bezwaarmeesters.nl in het kader van haar dienstverlening, inclusief maar niet beperkt tot de uitvoering van bezwaar- en beroepsprocedures.</p>
        <p><strong>1.4</strong> Bezwaarmeesters.nl verwerkt persoonsgegevens in overeenstemming met de Algemene Verordening Gegevensbescherming (“AVG”) en overige toepasselijke wet- en regelgeving.</p>
      </Section>

      <Section title="2. Verantwoordelijke voor de verwerking">
        <p><strong>2.1</strong> Bezwaarmeesters.nl is verwerkingsverantwoordelijke in de zin van de AVG.</p>
        <p><strong>2.2</strong> Bezwaarmeesters.nl kan verwerkers inschakelen voor de uitvoering van haar werkzaamheden. Met deze verwerkers worden verwerkersovereenkomsten gesloten conform artikel 28 AVG.</p>
      </Section>

      <Section title="3. Categorieën van verwerkte persoonsgegevens">
        <p><strong>3.1</strong> Bezwaarmeesters.nl verwerkt uitsluitend persoonsgegevens die noodzakelijk zijn voor de uitvoering van haar diensten, waaronder:</p>
        <ul>
          <li>Naam, adres, woonplaats (NAW-gegevens)</li>
          <li>Contactgegevens (e-mailadres, telefoonnummer)</li>
          <li>Geboortedatum</li>
          <li>Kenteken en voertuiggegevens</li>
          <li>Zaaknummers en referentienummers van boetes/beschikkingen</li>
          <li>Kopieën van poststukken, boetes, beschikkingen, aanmaningen, dwangbevelen</li>
          <li>Betaalgegevens (IBAN, betaalbewijzen, gegevens over ontvangen vergoedingen)</li>
          <li>Communicatie-inhoud (e-mails en brieven)</li>
          <li>IP-adres en technische gegevens van het gebruik van onze website</li>
        </ul>
        <p><strong>3.2</strong> In uitzonderlijke gevallen kan Bezwaarmeesters.nl bijzondere persoonsgegevens verwerken indien dit noodzakelijk is voor de behandeling van een zaak, bijvoorbeeld in het kader van medische omstandigheden die relevant zijn voor de beoordeling door een rechter.</p>
      </Section>

      <Section title="4. Doeleinden van de verwerking">
        <p>Bezwaarmeesters.nl verwerkt persoonsgegevens uitsluitend voor de volgende doeleinden:</p>
        <p><strong>a.</strong> Uitvoering van de overeenkomst: het behandelen van bezwaar- en beroepsprocedures, het opstellen en indienen van processtukken en het onderhouden van correspondentie met de cliënt en derden.</p>
        <p><strong>b.</strong> Nakoming van wettelijke verplichtingen, waaronder het verstrekken van gegevens aan bevoegde instanties zoals het CJIB, Parket CVOM, rechtbanken of gemeenten.</p>
        <p><strong>c.</strong> Financiële afwikkeling van de procedure, inclusief het innen of doorstorten van proceskostenvergoedingen, dwangsommen of schadevergoedingen.</p>
        <p><strong>d.</strong> Communicatie met de cliënt over diens dossier, voortgang en uitkomst van de zaak.</p>
        <p><strong>e.</strong> Verbetering van de dienstverlening en interne kwaliteitscontrole.</p>
        <p><strong>f.</strong> Marketing- en relatiebeheeractiviteiten, voor zover wettelijk toegestaan.</p>
      </Section>

      <Section title="5. Rechtsgrondslag voor de verwerking">
        <p>De verwerking van persoonsgegevens door Bezwaarmeesters.nl vindt uitsluitend plaats op basis van:</p>
        <ul>
          <li>Uitvoering van de overeenkomst (artikel 6 lid 1 sub b AVG);</li>
          <li>Voldoen aan wettelijke verplichtingen (artikel 6 lid 1 sub c AVG);</li>
          <li>Gerechtvaardigd belang van Bezwaarmeesters.nl, zoals fraudepreventie, interne administratie en marketing aan bestaande cliënten (artikel 6 lid 1 sub f AVG);</li>
          <li>Toestemming van de cliënt, indien vereist (artikel 6 lid 1 sub a AVG).</li>
        </ul>
      </Section>

      <Section title="6. Delen van persoonsgegevens met derden">
        <p><strong>6.1</strong> Bezwaarmeesters.nl verstrekt persoonsgegevens uitsluitend aan derden indien dit noodzakelijk is voor de uitvoering van de overeenkomst, om te voldoen aan een wettelijke verplichting, of indien de cliënt daarvoor toestemming heeft gegeven.</p>
        <p><strong>6.2</strong> Mogelijke ontvangers zijn:</p>
        <ul>
          <li>Het CJIB, Parket CVOM, rechtbanken en gerechtshoven;</li>
          <li>Gemeenten, waterschappen en andere bestuursorganen;</li>
          <li>Juridische partners, gemachtigden of procesvertegenwoordigers;</li>
          <li>Externe dienstverleners zoals IT-, hosting- en cloudproviders;</li>
          <li>Betaaldienstverleners en financiële instellingen;</li>
          <li>Belastingadviseurs en accountants.</li>
        </ul>
        <p><strong>6.3</strong> Met derden die als verwerker optreden, sluit Bezwaarmeesters.nl verwerkersovereenkomsten die voldoen aan de vereisten van de AVG.</p>
      </Section>

      <Section title="7. Bewaartermijnen">
        <p><strong>7.1</strong> Bezwaarmeesters.nl bewaart persoonsgegevens niet langer dan strikt noodzakelijk is voor de doeleinden waarvoor deze zijn verzameld, tenzij een langere wettelijke bewaartermijn van toepassing is.</p>
        <p><strong>7.2</strong> De standaardbewaartermijnen zijn:</p>
        <ul>
          <li>Zaakdossiers: 7 jaar na afronding van de zaak (fiscale bewaarplicht);</li>
          <li>Communicatiegegevens: 2 jaar na het laatste contactmoment;</li>
          <li>Marketinggegevens: totdat de betrokkene zich afmeldt.</li>
        </ul>
      </Section>

      <Section title="8. Beveiligingsmaatregelen">
        <p><strong>8.1</strong> Bezwaarmeesters.nl neemt passende technische en organisatorische maatregelen om persoonsgegevens te beveiligen tegen verlies, misbruik en onbevoegde toegang.</p>
        <p><strong>8.2</strong> Deze maatregelen omvatten onder meer:</p>
        <ul>
          <li>Versleutelde opslag van digitale gegevens;</li>
          <li>SSL-beveiliging voor de website en e-mail;</li>
          <li>Beperkte toegang tot persoonsgegevens voor bevoegde medewerkers;</li>
          <li>Regelmatige beveiligingsupdates en monitoring.</li>
        </ul>
      </Section>

      <Section title="9. Rechten van betrokkenen">
        <p><strong>9.1</strong> De cliënt heeft de volgende rechten met betrekking tot zijn persoonsgegevens:</p>
        <ul>
          <li>Recht op inzage;</li>
          <li>Recht op rectificatie;</li>
          <li>Recht op verwijdering (‘recht op vergetelheid’), voor zover wettelijk toegestaan;</li>
          <li>Recht op beperking van de verwerking;</li>
          <li>Recht op overdraagbaarheid van gegevens (dataportabiliteit);</li>
          <li>Recht om bezwaar te maken tegen verwerking op basis van gerechtvaardigd belang.</li>
        </ul>
        <p><strong>9.2</strong> Verzoeken tot uitoefening van deze rechten kunnen worden ingediend via <strong>info@bezwaarmeesters.nl</strong> onder vermelding van naam, adres en zaaknummer.</p>
        <p><strong>9.3</strong> Bezwaarmeesters.nl kan de identiteit van de verzoeker verifiëren voordat een verzoek wordt behandeld.</p>
      </Section>

      <Section title="10. Cookies en tracking">
        <p><strong>10.1</strong> Bezwaarmeesters.nl maakt gebruik van functionele en analytische cookies, en - indien wettelijk toegestaan - marketingcookies.</p>
        <p><strong>10.2</strong> Verdere informatie is te vinden in het afzonderlijke Cookiebeleid.</p>
      </Section>

      <Section title="11. Wijzigingen in het privacybeleid">
        <p><strong>11.1</strong> Bezwaarmeesters.nl behoudt zich het recht voor dit privacybeleid te wijzigen.</p>
        <p><strong>11.2</strong> De meest recente versie is altijd beschikbaar via de website.</p>
      </Section>

      <div className="mt-10 p-6 rounded-lg bg-slate-50 border border-slate-200">
        <div className="font-bold text-[#1e1b4b] mb-3">Contact</div>
        <div className="flex flex-wrap gap-4 text-sm text-slate-700">
          <div className="flex items-center gap-2"><Mail className="w-4 h-4 text-[#f26b1f]" /> <a href="mailto:info@bezwaarmeesters.nl" className="hover:text-[#1e1b4b]">info@bezwaarmeesters.nl</a></div>
        </div>
      </div>
    </article>
  </div>
);

export default Privacybeleid;
